import React from 'react';
import { PASSWORD_RULES } from '../utils/passwordPolicy';

// Live checklist under a password field: each rule ticks as the password meets it.
const PasswordChecklist: React.FC<{ password: string; className?: string }> = ({ password, className = '' }) => (
  <ul className={`mt-1.5 grid grid-cols-2 gap-x-4 gap-y-0.5 text-xs ${className}`} aria-live="polite">
    {PASSWORD_RULES.map((r) => {
      const ok = password.length > 0 && r.test(password);
      return (
        <li key={r.key} className={ok ? 'text-emerald-700 dark:text-emerald-400' : 'text-gray-500 dark:text-gray-400'}>
          <span aria-hidden="true">{ok ? '✓' : '○'}</span> {r.label}
        </li>
      );
    })}
  </ul>
);

export default PasswordChecklist;
